var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { createUseStyles } from 'react-jss';
import { useTheme } from '../../theme';
import { useMultipleMemoClasses, useMemoClasses } from '../../utils/hooks';
import { Text } from '..';
var useStyles = createUseStyles({
    base: {
        display: 'inline-block',
        boxSizing: 'border-box',
        border: 'var(--RUI-border-width) solid var(--RUI-color-neutral-lighter)',
        borderRadius: 'var(--RUI-border-radius)',
        width: 'fit-content',
        maxWidth: '350px',
        overflow: 'hidden',
        margin: 'var(--RUI-margin)',
        padding: 'var(--RUI-padding)',
    },
    baseOverrides: function (_a) {
        var theme = _a.theme;
        return (__assign({}, theme.overrides.Card.base));
    },
    header: {
        marginBottom: 'var(--RUI-margin)',
    },
    headerOverrides: function (_a) {
        var theme = _a.theme;
        return (__assign({}, theme.overrides.Card.header));
    },
    containerRowStyle: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    image: {
        height: '100%',
        width: '100%',
        '&:not(:last-child)': {
            marignBottom: 'calc(0.5 * var(--RUI-margin))',
        },
    },
    imageLeft: {
        width: '50%',
        alignSelf: 'center',
    },
    imageCenter: {
        height: '50%',
        width: '100%',
    },
    imageRight: {
        width: '50%',
        alignSelf: 'center',
    },
    imageOverrides: function (_a) {
        var theme = _a.theme;
        return (__assign({}, theme.overrides.Card.image));
    },
    content: {
        marginBottom: 'var(--RUI-margin)',
    },
    contentOverrides: function (_a) {
        var theme = _a.theme;
        return (__assign({}, theme.overrides.Card.content));
    },
    fullWidth: {
        maxWidth: '	none',
    },
    fullWidthOverrides: function (_a) {
        var theme = _a.theme;
        return (__assign({}, theme.overrides.Card.fullWidth));
    },
}, { name: 'RUICard' });
var Card = function (_a) {
    var imagePosition = _a.imagePosition, imageSrc = _a.imageSrc, className = _a.className, header = _a.header, footer = _a.footer, title = _a.title, titleVariant = _a.titleVariant, content = _a.content, body = _a.body, contentVariant = _a.contentVariant, fullWidth = _a.fullWidth, props = __rest(_a, ["imagePosition", "imageSrc", "className", "header", "footer", "title", "titleVariant", "content", "body", "contentVariant", "fullWidth"]);
    var theme = useTheme();
    var styles = useStyles({ theme: theme });
    var baseClasses = useMemoClasses([
        styles.base,
        fullWidth && styles.fullWidth,
        theme.overrides.Card.fullWidth && styles.fullWidthOverrides,
        theme.overrides.Card.base && styles.baseOverrides,
        'RUICard-base',
        className,
    ], [theme, className, fullWidth]);
    var _b = useMultipleMemoClasses([
        [styles.header, theme.overrides.Card.header && styles.headerOverrides, 'RUICard-header'],
        [styles.content, theme.overrides.Card.content && styles.contentOverrides, 'RUICard-content'],
    ], [theme]), headerClasses = _b[0], contentClasses = _b[1];
    var _c = useMultipleMemoClasses([
        [(imagePosition === 'left' || imagePosition === 'right') && styles.containerRowStyle, 'RUICard-container'],
        [
            styles.image,
            theme.overrides.Card.image && styles.imageOverrides,
            imagePosition === 'middle' && styles.imageCenter,
            imagePosition === 'left' && styles.imageLeft,
            imagePosition === 'right' && styles.imageRight,
            'RUICard-image',
        ],
    ], [theme, imagePosition]), containerClasses = _c[0], imageClasses = _c[1];
    return (React.createElement("div", __assign({ className: baseClasses }, props),
        React.createElement("div", { className: containerClasses },
            imageSrc && (imagePosition === 'top' || imagePosition === 'left') && (React.createElement("img", { src: imageSrc, className: imageClasses })),
            React.createElement("div", null,
                !header && title ? (React.createElement(Text, { className: headerClasses, variant: titleVariant }, title)) : (header),
                imageSrc && imagePosition === 'middle' && React.createElement("img", { src: imageSrc, className: imageClasses }),
                !body && content ? (React.createElement(Text, { variant: contentVariant, className: contentClasses }, content)) : (React.createElement("div", { className: contentClasses }, body))),
            imageSrc && (imagePosition === 'bottom' || imagePosition === 'right') && (React.createElement("img", { src: imageSrc, className: imageClasses }))),
        footer));
};
Card.defaultProps = {
    className: '',
    fullWidth: false,
    imagePosition: 'top',
    imageSrc: '',
    content: 'Lorem ipsum dolor sit amet',
    contentVariant: 'body1',
    title: 'Title header',
    titleVariant: 'title4',
    footer: '',
};
export { Card as default, Card };
